import newBaseTask from './newBaseTask';
import newChatTask from './newChatTask';
import newPreviewDialingTask from './newPreviewDialingTask';
import newTask from './newTask';
import reportableTasks from './reportableTasks';
import updatedBaseTask from './updatedBaseTask';
import updatedChatTask from './updatedChatTask';
import updatedPreviewDialingTask from './updatedPreviewDialingTask';
import updatedTask from './updatedTask';

export default {
  newTask,
  updatedTask,
  newChatTask,
  newPreviewDialingTask,
  newBaseTask,
  reportableTasks,
  updatedChatTask,
  updatedPreviewDialingTask,
  updatedBaseTask,
};
